import {PASearch} from "../PA.Core/PASearch";
import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Product_Type_Search_Fields: { [id:string]: ISearchProviderField } = {
    WB_PRDM_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB ProductType Id', columnResourceName: 'colWBProductTypeId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    PRDM_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Type Id', columnResourceName: 'colProductTypeId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    PRDM_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Product Type Name', columnResourceName: 'colProductTypeName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    MDSET_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Master Data Set', columnResourceName: 'colProductTypeMDSet', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    PRDM_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Entity Type', columnResourceName: 'colProductTypeEntityType', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    }
};

const ProductTypeSearchProviderBasis: ISearchProvider = {
    keyFields: {
        id: 'WB_PRDM_ID',
        id_ui: 'PRDM_ID',
        name: 'PRDM_NAME'
    },

    searchProviderFields: vUI_Product_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            const findRequest = SearchUtils.makeSearchRequest(
                searchOptions,
                'vUI_Product_Type_Search',
                this.searchProviderFields,
                []
            );

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
};

const ProductTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ProductTypeSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'PRDM_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'PRDM_NAME', renderOptions: {} },
        { profileFilterName: 'Master Data Set', searchProviderFieldId: 'MDSET_NAME', renderOptions: {} },
        { profileFilterName: 'Entity Type', searchProviderFieldId: 'PRDM_TYPE', renderOptions: {} },

    ],
    profileDisplayFields: [
        'PRDM_ID', 'PRDM_NAME', 'MDSET_NAME', 'PRDM_TYPE'
    ], // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductTypeSearchProviderBasis,

    profileSortIdDefault: "",
    profileSorts: []
};

const ProductTypeSearch: ISearch = {
    searchName: "Find Product Type",
    renderOptions: { ui5ResourceId: "ProductTypeSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [ProductTypeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ProductTypeBO","ProductType", ProductTypeSearch, "Product Type Search")


export { ProductTypeSearch };
